import React, { Component } from 'react';
import { Nav } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import HeaderRightMenu from './HeaderRightMenu';
import logo from '../assets/logo.png';
import sygnet from '../assets/icon.png';

import TopbarIotService from './TopbarIotService';
import SettingsMenu from './menus/SettingsMenu';
import UserMenu from './menus/UserMenu';
import ProjectsMenu from './menus/ProjectsMenu';
import config from '../config/constants'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class Header extends Component {
  render() {
    const { selected_project, logged_user } = this.props;
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand width="225"
          full={{ src: logo, width: 180, height: 32, alt: 'Robust Machines Logo' }}
          minimized={{ src: sygnet, width: 64, height: 64, alt: 'Robust Machines Logo' }}
        />
        {selected_project ? <AppSidebarToggler className="d-md-down-none" display="lg" /> : ""}
        <ProjectsMenu />
        <Nav className="ml-auto" navbar>
           <TopbarIotService />
          {logged_user ? logged_user.platform_role == config.PLATFORM_ROLE.admin  ? <SettingsMenu /> : '' : ''}
          <UserMenu />
        </Nav>
      </React.Fragment>
    );
  }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;


function mapStateToProps({ selected_project, logged_user }) {
  return {
    selected_project,
    logged_user
  };
}

export default connect(mapStateToProps, null)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header.js